import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['scriptArea', 'responseFrame', 'response']

  connect() {
    this.#bindScriptAreaInputs()
  }

  #bindScriptAreaInputs() {
    const inputs = this.scriptAreaTarget.querySelectorAll('input')
    inputs.forEach (input =>  { input.addEventListener('keyup', event => this.#updateResponse(event)) })
    const selects = this.scriptAreaTarget.querySelectorAll('select')
    selects.forEach (input => { input.addEventListener('change', event => this.#updateResponse(event)) })
  }

  #updateResponse(event) {
    const inputValue = event.currentTarget.value
    const targetUid =  event.currentTarget.parentNode.dataset.uid
    const target = this.responseFrameTarget.querySelector(`[data-uid="${targetUid}"]`)
    target.textContent = inputValue
    this.responseTarget.value = this.responseFrameTarget.innerHTML
  }
}
